import React from 'react';
import '../CSS/Niyojit.css';

const Niyojit = () => {

return (
<div className='Niyonit-Container'>
<h2 className='Niyojit-head'><span>नियोजित</span>उपक्रम</h2>

<div className='Niyojit-card'>

<div className='Niyojit-Cards-1'>
  <h2>साहित्य आणि काव्य उपक्रम</h2>
  <p> गावातील सार्वजनिक ठिकाणी कविता प्रदर्शन</p>
 <p>"घराघरात कविता" उपक्रम</p>
<p>"कविता कट्टा" (मासिक काव्यगोष्टी)</p>
<p>"गणेशोत्सव आणि नवरात्र विशेष काव्यगोष्टी"</p>
<p>"एक दिवस - एक कवी"</p>
</div>


<div className='Niyojit-Cards-2'>
  <h2>विशेष साहित्य संमेलन आणि प्रकाशन"</h2>
  <p>"माझं कवितांचं गाव" वार्षिक दिवाळी अंक"</p>
 <p>"गावकविता संमेलन" (वर्षातून दोन वेळा)"</p>
<p>"डिजिटल कविता संकलन" े</p>
<p>"गावातील कवींवर विशेष ग्रंथ प्रकाशन" </p>

</div>



<div className='Niyojit-Cards-3'>
  <h2>गावाकडील कवींसाठी संधी आणि पुरस्कार</h2>
  <p> "प्रेरणादायी कवी पुरस्कार"</p>
 <p>"जकातवाडी काव्य गौरख" पुरस्कार"</p>
<p>"गावात जन्मलेल्या किंवा येथे योगदान दिलेल्या साहित्यिकांचे सन्मान सोहळे"</p>

</div>


<div className='Niyojit-Cards-4'>
  <h2>विद्यार्थ्यांसाठी उपक्रम</h2>
  <p> "बालकवी संमेलन"</p>
 <p>"शिक्षक आणि पालकांसाठी कविता कार्यशाळा"</p>
<p>"शिक्षक आणि पालकांसाठी कविता कार्यशाळा"</p>
<p>"गणेशोत्सव आणि नवरात्र विशेष काव्यगोष्टी"</p>
<p>"पोस्टर कविता स्पर्धा"</p>
</div>

</div>

</div>



)



}

export default Niyojit;